/**
 * Pied de page léger — les trois liens légaux, posés au bas des Réglages et
 * de la page Chouette+. Volontairement discret (filet + petites capitales),
 * pour qu'il se lise comme une signature et pas comme une navigation.
 */
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function LegalFooter({ className = "" }: { className?: string }) {
  const { t } = useTranslation();
  const linkClass =
    "tap-target inline-flex items-center px-1 text-violet-muted underline decoration-line underline-offset-4";
  return (
    <nav
      aria-label={t("footer.legal")}
      className={`border-t border-line pt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs font-body ${className}`}
    >
      <Link to="/terms" className={linkClass}>{t("footer.terms")}</Link>
      <Link to="/privacy" className={linkClass}>{t("footer.privacy")}</Link>
      <Link to="/legal" className={linkClass}>{t("footer.legal")}</Link>
    </nav>
  );
}
